export enum PERMISSIONS {
  TRANSACTION = 'transaction:view',

  DISBURSEMENTS = 'disbursements:view',
  DEPOSIT = 'deposit:view',
  WITHDRAW = 'withdraw:view',

  DEVELOPER_TOOLS = 'developerTools:view',
  TEAM = 'team:view',

  MERCHANT_USERS = 'merchantUsers:view',

  SANDBOX = 'sandbox:view',

  MANAGE_ACCOUNT_BANK = 'bankAccount:edit',
  MANAGE_ACCOUNT_BLOCKCHAIN_ADDRESS = 'blockChainAddress:edit',

  INVOICING = 'invoicing:edit',

  CREDIT_CARDS = 'creditCards:view',
}
